// type.ts
export interface ICreateInitial<IRoot = any> {
    _root: IRoot | null;
    mount: (selector: string) => void;
    unmount: () => void;
}

export interface IReactDOMAdapter {
    render: (element: JSX.Element, container: Element) => any;
    unmount: (container: Element, root: any) => void;
}


export type TReactDOMAdapterFunction = (ReactDOM: any) => IReactDOMAdapter

export interface ICreateComponentSuspenseOptions {
    className?: string;
    mcfeId?: string;
    LoadingComponent?: React.ComponentType<any>;
    ErrorComponent?: React.ComponentType<any>;
}